<template>
    <div
        class="pos-fixed pos-left pos-center-y ml-5 text-white text-size-5 text-uppercase shadow-t-5 hidden-touch"
        style="z-index: 50"
        @mouseenter="showTitles = true"
        @mouseleave="showTitles = false"
    >
        <div
            class="d-flex flex-align-center cursor-pointer"
            style="transform: translateX(-1.5rem); margin-left: 0.25rem"
            @click="$emit('click', 0)"
        >
            <LogoCircle
                class="text-white"
                style="
                    height: 3rem;
                    width: 3rem;
                    filter: drop-shadow(0px 0px 7px rgba(0, 0, 0, 0.3));
                    fill: currentColor;
                "
            />
            <BrandBookLogoText
                :style="{
                    opacity: showTitles ? 1 : 0,
                    transition: `opacity ${animationDuration}ms ease-in-out`,
                }"
                :animation-duration="animationDuration"
                class="text-white"
            />
        </div>
        <nav class="pos-relative">
            <div
                class="bg-white shadow-5 pos-absolute"
                style="
                    width: 2px;
                    margin-left: 0.25rem;
                    opacity: 0.25;
                    top: 1rem;
                    bottom: 1rem;
                    transform: translateX(-50%);
                "
            />
            <ul class="no-list" v-for="(title, index) in titles">
                <BrandBookSideBarItem
                    :title="title"
                    :show-title="showTitles"
                    :is-active="index === activeSectionIndex"
                    @click.native="$emit('click', index)"
                />
            </ul>
        </nav>
    </div>
</template>

<script>
    import BrandBookSideBarItem from './BrandBookSideBarItem';
    import LogoCircle from './LogoCircle';
    import LogoTextH from './LogoTextH';
    import BrandBookLogoText from './BrandBookLogoText';

    export default {
        name: 'BrandBookSideBar',

        components: {
            BrandBookLogoText,
            LogoTextH,
            LogoCircle,
            BrandBookSideBarItem,
        },

        props: {
            titles: {
                type: Array,
                required: true,
            },
            activeSectionIndex: {
                type: Number,
                required: true,
            },
        },

        data() {
            return {
                showTitles: false,
                animationDuration: 750,
            };
        },
    };
</script>
